var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgImgUpload = function SvgImgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.136 29.954v7.364H54.5v4.91h-7.364v7.363h-4.909v-7.364h-7.363v-4.909h7.363v-7.363h4.91ZM47.156.5a2.437 2.437 0 0 1 2.435 2.437v22.108h-4.91V5.41H5.41V39.77l24.546-24.543 7.363 7.364v6.944l-7.363-7.364-17.607 17.602h17.606v4.909H2.934A2.437 2.437 0 0 1 .5 42.244V2.938A2.455 2.455 0 0 1 2.935.5h44.221Zm-31.929 9.818a4.91 4.91 0 1 1 0 9.818 4.91 4.91 0 0 1 0-9.818Z",
    fill: "#111"
  })));
};

export default SvgImgUpload;